module.exports = __webpack_public_path__ + "img/contact.5c4586c6.png";